import React from "react";
import { GlobalFooter, GlobalHeader, SEO } from "components";
import { WpPostTypeSeo } from "codegen";
import classNames from "classnames";

interface LayoutProps {
  className?: string;
  children?: JSX.Element;
  pageTitle?: string;
  seo?: WpPostTypeSeo;
}

/**
 * Component that will wrap children in containers
 *
 * @param className If a custom class needs to be applied to the site container
 * @param pageTitle - Page title to be passed to SEO component
 * @param seo - Data from yoast, to be sent to SEO component
 * @returns A wrapper for all pages containing the GlobalHeader, GlobalFooter and contianing divs
 *
 */
export const Layout = ({ children, className, pageTitle = "", seo = null }: LayoutProps): JSX.Element => {
  return (
    <>
      <SEO title={pageTitle} seo={seo} />
      <div
        className={classNames({
          "site-container": true,
          [`${className}`]: className,
        })}
      >
        <GlobalHeader />
        <main>{children}</main>
        <GlobalFooter />
      </div>
    </>
  );
};
